import React from 'react';
import ToolTip from '@atlaskit/tooltip';
import type { ExtraFieldText } from '../../../../../../model/extra-fields/types';
import { Container } from '../styled';
import { isDefault, parseContent } from '../utils';

type Props = { field: ExtraFieldText };

export function TextField({ field }: Props) {
	const content = parseContent(field.text);
	return (
		<ToolTip content={field.label}>
			<Container
				aria-label={field.label}
				aria-hidden={isDefault(content) ? 'true' : 'false'}
				isDefault={isDefault(content)}
			>
				{content}
			</Container>
		</ToolTip>
	);
}
